import { render, staticRenderFns } from "./SmtAccordion.vue?vue&type=template&id=7c382d3e&scoped=true"
import script from "./SmtAccordion.vue?vue&type=script&lang=js"
export * from "./SmtAccordion.vue?vue&type=script&lang=js"
import style0 from "./SmtAccordion.vue?vue&type=style&index=0&id=7c382d3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c382d3e",
  null
  
)

export default component.exports